import type {
  CubeHellPlayer,
  CubeHellPlayerId,
  CubeHellState,
  InitGameOptions,
} from "./types";
import {
  CUBE_HELL_DEFAULT_GUESS_PENALTY,
  CUBE_HELL_DEFAULT_MAX_QUERIES,
  CUBE_HELL_PLAYERS,
} from "./types";
import { generateArrangement } from "./utils";

function createPlayer(playerId: CubeHellPlayerId): CubeHellPlayer {
  return { playerId, label: playerId === "p1" ? "선" : "후" };
}

export function initGame(options: InitGameOptions = {}): CubeHellState {
  const firstPlayer = options.firstPlayerId ?? "p1";
  if (!CUBE_HELL_PLAYERS.includes(firstPlayer)) {
    throw new Error("First player must be p1 or p2");
  }
  const seed = options.seed ?? 1;

  // Both arrangements come from one seed stream → fully deterministic.
  const first = generateArrangement(seed);
  const second = generateArrangement(first.state);

  return {
    gameId: options.gameId ?? `cube-hell-${CUBE_HELL_PLAYERS.join("-")}`,
    players: CUBE_HELL_PLAYERS.map(createPlayer),
    phase: "query",
    currentPlayerId: firstPlayer,
    arrangements: { p1: first.arrangement, p2: second.arrangement },
    log: [],
    queryCounts: { p1: 0, p2: 0 },
    rngState: second.state,
    winnerId: null,
    lastAction: null,
    moveNumber: 0,
    guessPenalty: options.guessPenalty ?? CUBE_HELL_DEFAULT_GUESS_PENALTY,
    maxQueriesPerPlayer:
      options.maxQueriesPerPlayer ?? CUBE_HELL_DEFAULT_MAX_QUERIES,
  };
}
